import {AsyncStatusesEnum} from '../../libs/shared/helpers/src/types/asyncStatuses';
import {AsyncStatus, ResourceTableStatusesEnum} from '../store/appTypes';

// Takes an array of AsyncStatus's and spits out 1 AsyncStatus that represents all of them.
export function mergeAsyncStatuses(asyncStatuses: ReadonlyArray<AsyncStatus>): AsyncStatus {
  const status = asyncStatuses.reduce(mergeTwoAsyncStatuses, undefined);
  return status || unexpectedLoadingErrorStatus;
}

export const AsyncStatusFromResourceTableStatus: Record<ResourceTableStatusesEnum, AsyncStatusesEnum> = {
  [ResourceTableStatusesEnum.INITIAL]: AsyncStatusesEnum.LOADED,
  [ResourceTableStatusesEnum.LOADING]: AsyncStatusesEnum.LOADING,
  [ResourceTableStatusesEnum.LOADED]: AsyncStatusesEnum.LOADED,
  [ResourceTableStatusesEnum.FAILED]: AsyncStatusesEnum.FAILED,
};

// If the statuses are different, we return the first that has the semantic property that appears first in this list:
// [error, not loaded, loading, stale, loaded]
function mergeTwoAsyncStatuses(
  asyncStatusA?: AsyncStatus,
  asyncStatusB?: AsyncStatus,
): AsyncStatus | undefined {
  // Return the other if one is undefined.
  if (!asyncStatusA) {
    return asyncStatusB;
  }
  if (!asyncStatusB) {
    return asyncStatusA;
  }

  // Failed.
  if (asyncStatusA.status === ResourceTableStatusesEnum.FAILED) {
    return asyncStatusA;
  }
  if (asyncStatusB.status === ResourceTableStatusesEnum.FAILED) {
    return asyncStatusB;
  }

  // Initial.
  if (asyncStatusA.status === ResourceTableStatusesEnum.INITIAL) {
    return asyncStatusA;
  }
  if (asyncStatusB.status === ResourceTableStatusesEnum.INITIAL) {
    return asyncStatusB;
  }

  // Loading.
  if (asyncStatusA.status === ResourceTableStatusesEnum.LOADING) {
    return asyncStatusA;
  }
  if (asyncStatusB.status === ResourceTableStatusesEnum.LOADING) {
    return asyncStatusB;
  }

  // Stale.
  if (asyncStatusA.isStale) {
    return asyncStatusA;
  }
  if (asyncStatusB.isStale) {
    return asyncStatusB;
  }

  // Loaded.
  if (asyncStatusA.status === ResourceTableStatusesEnum.LOADED) {
    return asyncStatusA;
  }
  if (asyncStatusB.status === ResourceTableStatusesEnum.LOADED) {
    return asyncStatusB;
  }

  // Shouldn't get here.
  return asyncStatusA;
}

const unexpectedLoadingErrorStatus: AsyncStatus = {
  status: ResourceTableStatusesEnum.FAILED,
  isStale: false,
  error: 'Unexpected loading error',
};
